<div class="detalle-clientes">
  <mat-form-field appearance="outline" class="detalle-buscador">
    <mat-label>Buscar cliente</mat-label>
    <input
      matInput
      (keyup)="aplicarFiltro($any($event.target).value)"
      placeholder="Nombre del cliente"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="detalle-tabla-scroll">
    <table mat-table [dataSource]="dataSource" matSort class="detalle-tabla">
      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
        <td mat-cell *matCellDef="let h">{{ h.nombre || h.idCliente }}</td>
      </ng-container>

      <ng-container matColumnDef="trackers">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Trackers</th>
        <td mat-cell *matCellDef="let h">
          {{ h.trackers?.cantidad ?? 0 | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="alarmas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Alarmas</th>
        <td mat-cell *matCellDef="let h">
          {{ h.alarmas?.cantidad ?? 0 | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="camaras">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cámaras</th>
        <td mat-cell *matCellDef="let h">
          {{ h.camaras?.cantidad ?? 0 | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
        <td mat-cell *matCellDef="let h">
          <strong>{{ h.total ?? 0 | number }}</strong>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnas"></tr>
      <tr mat-row *matRowDef="let row; columns: columnas"></tr>

      <tr class="detalle-fila-vacia" *matNoDataRow>
        <td class="detalle-sin" [attr.colspan]="columnas.length">
          Sin clientes.
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 50]"
    [pageSize]="5"
    showFirstLastButtons
  ></mat-paginator>
</div>
